import { useTranslation } from 'react-i18next';
import { PUBLIC_SET_TRANSLATION_ENABLED } from 'src/api';
import axios from 'src/axios';
import { CardBody, CardContainer, Switch } from 'src/components/atoms';
import { ShadowsSize } from 'src/components/foundations/tokens';
import { handleErrorToast, handleSuccessToast } from 'src/components/molecules';
import { PublicLoggedInContainerWithNavbar } from 'src/components/organismsLegacy/LoggedInContainer/PublicLoggedInContainerWithNavbar';
import * as Types from '../../../types';
import {
  LeftSide,
  RightSide,
  StyledSubDescription,
  StyledSubHeader,
  StyledSubSection,
} from './MessageSettings.styles';

interface Props {
  currentUser: Types.User;
  organisation: string;
  updateTranslationEnabled: (value: boolean) => void;
}

export const MessageSettings = ({
  organisation,
  currentUser,
  updateTranslationEnabled,
}: Props) => {
  const { t } = useTranslation();
  const handleTranslationToggle = async (newToggleValue: boolean) => {
    try {
      if (!currentUser.id) {
        throw new Error('User not found');
      }
      await axios.put(
        PUBLIC_SET_TRANSLATION_ENABLED(currentUser.id, newToggleValue),
      );
      updateTranslationEnabled(newToggleValue);
      handleSuccessToast({
        toastMessage: t('public.MessageSettings.updateTranslationSuccess'),
      });
    } catch (error) {
      handleErrorToast({
        toastMessage: t('public.MessageSettings.updateTranslationFailed'),
      });
    }
  };

  return (
    <PublicLoggedInContainerWithNavbar
      organisation={organisation}
      currentUser={currentUser}
      selectedTabIndex={1}
      hideMenusWhenSmall
      greyBackground={false}
      hideID
    >
      <CardContainer
        $shadowSize={ShadowsSize.large}
        $width="85%"
        $margin="20px"
      >
        <CardBody>
          <StyledSubSection>
            <LeftSide>
              <StyledSubHeader>
                {t('public.MessageSettings.enableTranslationsHeader')}
              </StyledSubHeader>
              <StyledSubDescription>
                {t('public.MessageSettings.enableTranslationsDescription')}
                <br />
                <br />
                {t('public.MessageSettings.enableTranslationsSubDescriptionv2')}
              </StyledSubDescription>
            </LeftSide>
            <RightSide>
              <Switch
                label={
                  currentUser?.translationEnabled
                    ? t('public.MessageSettings.enableTranslationLabelEnabled')
                    : t('public.MessageSettings.enableTranslationLabelDisabled')
                }
                data-testid="opr-translation-toggle"
                checked={currentUser?.translationEnabled ?? false}
                onClick={() =>
                  handleTranslationToggle(!currentUser?.translationEnabled)
                }
              />
            </RightSide>
          </StyledSubSection>
        </CardBody>
      </CardContainer>
    </PublicLoggedInContainerWithNavbar>
  );
};

export default MessageSettings;
